import { useEffect, useState } from "react";
import Lenis from "lenis";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Chapters from "@/components/Chapters";
import Contact from "@/components/Contact";
import Payment from "@/components/Payment";
import Footer from "@/components/Footer";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";
import IntroSplash from "@/components/IntroSplash";
import { INTRO_SEEN } from "@/lib/intro";
import { registerLenis } from "@/lib/scroll";

function App() {
  const [intro, setIntro] = useState(!INTRO_SEEN);

  useEffect(() => {
    const lenis = new Lenis({ autoRaf: true, duration: 1.1 });
    registerLenis(lenis);
    return () => {
      registerLenis(null);
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    if (!intro) return;
    const t = setTimeout(() => {
      setIntro(false);
      sessionStorage.setItem("ksr-intro-seen", "1");
    }, 1600);
    return () => clearTimeout(t);
  }, [intro]);

  return (
    <div className="grain min-h-screen bg-[#FAF7F2] text-[#2A1810] antialiased">
      <IntroSplash show={intro} />
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Chapters />
        <Contact />
        <Payment />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}

export default App;
